import { PageState } from "src/app/core/base-page";
import { Entity } from "src/app/core/data/schema/entity";
import { DateTimeHelper } from "src/app/core/helper/datetime.helper";
import { Survey } from "./survey";

export class SurveyResponse extends Entity {

    static className = 'SurveyResponse';
    static idField = 'surveyResponseId';
    static friendlyName = 'Response';

    surveyResponseId: number;
    surveyId: number;
    surveyName: string;
    forUserId: number;
    forName: string;
    forEmail: string;
    byUserId: number;
    completedOn: string;
    completedBy: string;
    completedOnFmt: string;
    source: string;
    sourceType: string;
    eventInstanceStartDate: Date;
    lastModifiedBy: string;
    lastModifiedAt: string;
    lastModifiedAtFmt: string;
    surveyAnswers: SurveyAnswer[] = [];
    transactionId: number;
    fundraisingCampaignId: number;
    marketingCampaignId: number;
    fromExternalSource: boolean;

    // because the table dynamically generates the columns based on the survey questions,
    // and we need to display the answer and feedback pairs according to if feedback is enabled for the question
    // the data table isn't smart enough so we build up this array to only include data for the relevant columns
    answerFeedbackPair: string[] = [];

    constructor(init?: Partial<SurveyResponse>) {
        super('SurveyResponse', 'surveyResponseId', 'SurveyResponses');
        Object.assign(this, init);

        if (this.surveyAnswers) {
            this.surveyAnswers = this.surveyAnswers.map(answer => new SurveyAnswer(answer));
        }

        if (this.completedOn) {
            this.completedOnFmt = DateTimeHelper.formatDate(this.completedOn + 'Z');
        }

        if (this.lastModifiedAt) {
            this.lastModifiedAtFmt = DateTimeHelper.formatDate(this.lastModifiedAt + 'Z');
        }
    }

    public static createFromSurvey(survey: Survey) {
        const surveyResponse = new SurveyResponse({
            surveyId: survey.surveyId,
            surveyAnswers: survey.surveyQuestions.map(q => {
                const response = q.getUserResponse();
                return new SurveyAnswer({
                    questionId: q.questionId,
                    answer: response.answer,
                    feedback: response.feedback,
                });
            })
        });
        return surveyResponse;
    }

    public static async load(id: number) {
        return await SurveyResponse.getByIdNoCache(SurveyResponse, id);
    }

    public override async save(busyState?: PageState) {
        return await super.save(busyState);
    }

    get sourceName(): string {
        if (this.eventInstanceStartDate) {
            return `${this.source} (${DateTimeHelper.formatDate(this.eventInstanceStartDate, false, true)})`;
        } else {
            return this.source;
        }
    }
}

export class SurveyAnswer {
    answerId: number;
    surveyResponseId?: number;
    questionId: number;
    questionText?: string;
    answer: string;
    feedback: string;
    answeredOn: string;

    constructor(init?: Partial<SurveyAnswer>) {
        Object.assign(this, init);
    }
}

